"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  BUTTON_TYPES: true,
  NATIVE_HTML_BUTTON_TYPES: true,
  Button: true
};
exports.default = exports.NATIVE_HTML_BUTTON_TYPES = exports.Button = exports.BUTTON_TYPES = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _isReactFragment = require("../utils/isReactFragment");
var _Icon = require("../Icon/Icon");
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _ToolbarOverflowLayout = require("../Toolbar/_ToolbarOverflowLayout");
var _utils = require("./utils");
var _Button = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Button.css") : void 0);
var _Button2 = require("./Button.types");
Object.keys(_Button2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Button2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Button2[key];
    }
  });
});
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-button';
const BUTTON_TYPES = exports.BUTTON_TYPES = ['default', 'primary', 'secondary', 'success', 'info', 'warning', 'danger', 'error', 'link', 'create'];
const NATIVE_HTML_BUTTON_TYPES = exports.NATIVE_HTML_BUTTON_TYPES = ['button', 'reset', 'submit'];
/**
 * **Button** components are used to communicate and trigger an action, when interacted with.
 * If the user is being redirected to another page
 * in or outside of the application use a **Link** instead of a **Button**.
 */
const Button = exports.Button = /*#__PURE__*/_react.default.forwardRef((_props, ref) => {
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const props = addChildProps ? Object.assign(Object.assign({}, _props), addChildProps(Button, _props)) : _props;
  const {
      active,
      allowFocusOnDisable = false,
      children,
      className,
      compact,
      disabled,
      forceSize,
      disabledMessage,
      enabledMessage,
      hideCreateIcon,
      innerProps,
      innerTextClasses,
      innerTextProps,
      nativeHTMLButtonType = 'button',
      type = 'default',
      onClick,
      inToolbarOverflow,
      toolbarOverflowEnd,
      toolbarLayoutProps,
      disableInnerStyles,
      valueState
    } = props,
    otherProps = __rest(props, ["active", "allowFocusOnDisable", "children", "className", "compact", "disabled", "forceSize", "disabledMessage", "enabledMessage", "hideCreateIcon", "innerProps", "innerTextClasses", "innerTextProps", "nativeHTMLButtonType", "type", "onClick", "inToolbarOverflow", "toolbarOverflowEnd", "toolbarLayoutProps", "disableInnerStyles", "valueState"]);
  const classnames = _bind.default.bind(_Button.default);
  const classes = classnames(CSS_BLOCK, {
    [`${CSS_BLOCK}--active`]: active,
    [`${CSS_BLOCK}--${type}`]: type && !valueState,
    [`${CSS_BLOCK}--value-${valueState}`]: valueState,
    [`${CSS_BLOCK}--compact`]: compact && type === 'link',
    [`${CSS_BLOCK}--compact-density`]: forceSize === 'compact'
  }, className);
  const innerClasses = classnames({
    [`${CSS_BLOCK}__inner`]: !disableInnerStyles
  }, innerProps === null || innerProps === void 0 ? void 0 : innerProps.className);
  const ariaDisabled = otherProps['aria-disabled'];
  const disabledInAnyWay = disabled || ariaDisabled;
  // if button is disabled and focusable, remove onClick handler
  const onClickHandler = allowFocusOnDisable && disabledInAnyWay ? () => {} : onClick;
  const ariaLiveId = (0, _useUniqueId.default)();
  (0, _react.useEffect)(() => {
    (0, _utils.validateProps)(_props);
  }, [_props]);
  const passChildProps = (child, childProps) => {
    const {
      className: childClassName
    } = childProps;
    if (child.displayName === 'BusyIndicator') {
      return {
        className: classnames(`${CSS_BLOCK}__busy-indicator`, childClassName),
        circleClassName: classnames(`${CSS_BLOCK}__busy-indicator-circles`, childProps === null || childProps === void 0 ? void 0 : childProps.circleClassName)
      };
    }
    if (child.displayName === 'Badge') {
      return {
        className: classnames(`${CSS_BLOCK}__badge`, childClassName)
      };
    }
    if (child.displayName === 'Icon') {
      // Future breaking change:
      // The classForSemanticIconInButton isn't necessary
      const {
        iconName,
        size
      } = childProps;
      const SEMANTIC_ICONS = ['messaging-success', 'messaging-info', 'messaging-warning', 'messaging-error', 'messaging-help'];
      let svgIconProps = {};
      if (iconName && SEMANTIC_ICONS.indexOf(iconName) !== -1) {
        svgIconProps = {
          path1ClassName: classnames(`${CSS_BLOCK}__icon-path1`, childProps === null || childProps === void 0 ? void 0 : childProps.path1ClassName),
          path2ClassName: classnames(`${CSS_BLOCK}__icon-path2`, childProps === null || childProps === void 0 ? void 0 : childProps.path2ClassName)
        };
      }
      return Object.assign({
        className: classnames(`${CSS_BLOCK}__icon`, childClassName),
        size: size || 'sm'
      }, svgIconProps);
    }
    return null;
  };
  const getDisabledProps = () => {
    const disabledProps = {};
    if (allowFocusOnDisable) {
      disabledProps['aria-disabled'] = disabledInAnyWay;
      disabledProps['aria-describedby'] = ariaLiveId;
    } else {
      disabledProps.disabled = (0, _utils.toBoolean)(disabledInAnyWay);
    }
    return disabledProps;
  };
  const createIcon = type === 'create' && !hideCreateIcon && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    ariaHidden: true,
    iconName: "plus"
  });
  const renderChildren = childNodes => {
    let textNodeSegment = [];
    const innerTextClassName = classnames(innerTextClasses, `${CSS_BLOCK}__text`);
    let startIconOrBadge = createIcon;
    const centerText = [];
    let endIconOrBadge;
    const alteredChildren = _react.default.Children.map(childNodes, child => {
      var _a, _b, _c, _d;
      if (child === null) return null;
      if ((0, _isReactFragment.isReactFragment)(child)) {
        return renderChildren(child.props.children);
      }
      const isIconOrBadge = ((_a = child.type) === null || _a === void 0 ? void 0 : _a.displayName) === 'Icon' || ((_b = child.type) === null || _b === void 0 ? void 0 : _b.displayName) === 'Badge';
      const isTextNodeSegment = ((_c = child.type) === null || _c === void 0 ? void 0 : _c.displayName) !== 'Icon' && ((_d = child.type) === null || _d === void 0 ? void 0 : _d.displayName) !== 'Badge' || ! /*#__PURE__*/_react.default.isValidElement(child);
      if (isIconOrBadge) {
        if (!startIconOrBadge && !(centerText === null || centerText === void 0 ? void 0 : centerText.length)) {
          startIconOrBadge = child;
        } else {
          endIconOrBadge = child;
        }
      }
      if (isTextNodeSegment) {
        centerText.push(child);
        textNodeSegment.push(child);
      } else {
        if (textNodeSegment.length) {
          const textChild = textNodeSegment;
          textNodeSegment = [];
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", Object.assign({}, innerTextProps, {
            className: innerTextClassName
          }), textChild), child);
        }
        return child;
      }
      return null;
    });
    if (inToolbarOverflow) {
      return /*#__PURE__*/_react.default.createElement(_ToolbarOverflowLayout.ToolbarOverflowLayout, Object.assign({
        startIconOrBadge: startIconOrBadge,
        innerTextClassName: innerTextClassName,
        centerText: centerText,
        toolbarOverflowEnd: toolbarOverflowEnd,
        endIconOrBadge: endIconOrBadge
      }, toolbarLayoutProps));
    }
    if (textNodeSegment.length) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, alteredChildren, /*#__PURE__*/_react.default.createElement("span", Object.assign({}, innerTextProps, {
        className: innerTextClassName
      }), textNodeSegment));
    }
    return alteredChildren;
  };
  const buttonComp = /*#__PURE__*/_react.default.createElement("button", Object.assign({}, otherProps, getDisabledProps(), {
    className: classes,
    onClick: onClickHandler,
    ref: ref,
    // eslint-disable-next-line react/button-has-type
    type: nativeHTMLButtonType
  }), /*#__PURE__*/_react.default.createElement("span", Object.assign({}, innerProps, {
    className: innerClasses
  }), /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: passChildProps
  }, !inToolbarOverflow && createIcon, renderChildren(children))));
  const liveMessageForScreenReaders = disabledInAnyWay ? disabledMessage : enabledMessage;
  const renderButtonStateMessage = () => {
    let content = '';
    if (allowFocusOnDisable && disabledInAnyWay !== null) {
      content = /*#__PURE__*/_react.default.createElement("p", {
        "aria-live": "assertive",
        className: classnames(`${CSS_BLOCK}--screen-reader-only`),
        id: ariaLiveId
      }, liveMessageForScreenReaders);
    }
    return content;
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, buttonComp, renderButtonStateMessage());
});
Button.displayName = 'Button';
var _default = exports.default = Button;